module.exports = __webpack_public_path__ + "img/next-page.2bca18ae.png";